import React from 'react';

import { ArrowInCircleRightIcon } from '@vlabs/icons';
import { buildTestid } from '@vlabs/monokit/shared/lib/utils';
import { Control } from '@vlabs/uikit';
import type { IconButtonProps } from '@vlabs/uikit/components/controls/button/icon-button';
import { routes } from '@vlapps/point/src/app/routes';
import { useTranslation } from 'react-i18next';
import { generatePath } from 'react-router-dom';

import type { ViewCardProps } from './types';

const displayName = 'ViewPersonDetailsIconButton';
const testid = buildTestid(displayName);

function ViewCardIconButton({
  cardId,
  className = undefined,
  'data-testid': dataTestId = undefined,
  ...props
}: ViewCardProps & IconButtonProps): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <Control.IconButton
      className={className}
      icon={<ArrowInCircleRightIcon />}
      kind="secondary"
      size="small"
      variant="outlined"
      {...testid(dataTestId)}
      {...props}
      as="a"
      href={generatePath(routes.externalId.read, { externalId: cardId })}
    >
      {t('card-list-page:person card.details')}
    </Control.IconButton>
  );
}

export { ViewCardIconButton };
